export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: "https://roar-v3-dev-surveyadmin-service.azurewebsites.net/api",
  keycloak: {
    url: 'https://dev-sso.roarinc.it/',
    realm: 'CustomerConnect-Dev',
    clientId: 'surveyadmin-spa'
  }
};